import React, { Component } from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { withStyles } from "@material-ui/core";

import "./Policy.scss";

const styles = () => ({
  linearColorPrimary: {
    backgroundColor: "rgba(35, 45, 75, 0.2)",
    height: 12,
  },
  linearBarColorPrimary: {
    backgroundColor: "#232d4b",
    height: 12,
  },
  linearColorSecondary: {
    backgroundColor: "rgba(229, 114, 0, 0.2)",
    height: 12,
  },
  linearBarColorSecondary: {
    backgroundColor: "#e57200",
    height: 12,
  },
});

class PolicyItem extends Component {
  constructor(props) {
    super(props);

    Object.keys(props.policyDetails.values).includes("0") && props.dist
      ? (this.state = {
          values: [
            0,
            parseInt(parseFloat(props.dist[0]) * 100),
            parseInt(
              parseFloat(props.dist[0]) * 100 + parseFloat(props.dist[1]) * 100
            ),
            100,
          ],
          hasChanged: props.hasChanged,
        })
      : (this.state = {
          values: [
            0,
            props.dist ? parseInt(parseFloat(props.dist[0]) * 100) : 33.33,
            props.dist
              ? parseInt(
                  parseFloat(props.dist[0]) * 100 +
                    parseFloat(props.dist[1]) * 100
                )
              : 66.67,
            100,
          ],
          hasChanged: props.hasChanged,
        });
  }

  onHeadingClicked = (e) => {
    const policyOuter = e.currentTarget.parentElement;
    let policy = policyOuter.parentElement;

    let policy_list = policy.parentElement.parentElement.parentElement;

    const description = policy.querySelector(".ps__description");
    const height = 48 + description.clientHeight + "px";

    policy.classList.toggle("is-expanded");
    if (policy.classList.contains("is-expanded")) {
      policy.style.maxHeight = height;
      policy_list.style.maxHeight =
        policy_list.style.maxHeight.split("px")[0] +
        description.clientHeight +
        "px";
    } else {
      policy.style.maxHeight = "48px";
      policy_list.style.maxHeight =
        policy_list.style.maxHeight.split("px")[0] -
        description.clientHeight +
        "px";
    }
  };

  policyValueChanged = (e, pId) => {
    const { value } = e.target;
    this.setState(() => ({
      hasChanged: this.props.onPolicyValueChanged(value, pId),
    }));
  };

  sliderValueChange = (e) => {
    this.setState(() => ({
      values: [0, e[1], e[2], 100],
    }));
  };

  shouldComponentUpdate = (nextProps) => {
    if (!nextProps.hasChanged && this.state.hasChanged) {
      this.setState(() => ({
        hasChanged: false,
        values: [
          0,
          nextProps.dist
            ? parseInt(parseFloat(nextProps.dist[0]) * 100)
            : 33.33,
          nextProps.dist
            ? parseInt(
                parseFloat(nextProps.dist[0]) * 100 +
                  parseFloat(nextProps.dist[1]) * 100
              )
            : 66.67,
          100,
        ],
      }));
    }

    if (nextProps.dist && !this.props.dist) {
      this.setState(() => ({
        hasChanged: false,
        values: [
          0,
          nextProps.dist
            ? parseInt(parseFloat(nextProps.dist[0]) * 100)
            : 33.33,
          nextProps.dist
            ? parseInt(
                parseFloat(nextProps.dist[0]) * 100 +
                  parseFloat(nextProps.dist[1]) * 100
              )
            : 66.67,
          100,
        ],
      }));
    }

    return true;
  };

  render() {
    const {
      policyDetails,
      onPolicyValueChanged,
      value,
      classes,
      dist,
    } = this.props;
    const { values, hasChanged } = this.state;
    return (
      <div className="policy">
        <div className="ps__headingWrap flex flex-50-50">
          <h5
            className="ps__heading p1 container"
            onClick={this.onHeadingClicked}
          >
            {policyDetails.name} &#9432;
          </h5>
          {Object.keys(policyDetails.values).includes("0") ? (
            <div className="container p1">
              <Range
                allowCross={true}
                value={values}
                pushable={false}
                count={3}
                onChange={this.sliderValueChange}
                disabled={
                  !this.props.hasGameStarted || !this.props.gameHasAdvanced
                    ? true
                    : false
                }
                onAfterChange={() => {
                  const polChanged = onPolicyValueChanged(
                    null,
                    policyDetails.id,
                    [
                      (values[1] - values[0]) / 100.0,
                      (values[2] - values[1]) / 100.0,
                      (values[3] - values[2]) / 100.0,
                    ]
                  );
                  this.setState(() => ({
                    hasChanged: polChanged,
                    values: polChanged
                      ? values
                      : [
                          0,
                          parseInt(parseFloat(dist[0]) * 100),
                          parseInt(
                            parseFloat(dist[0]) * 100 +
                              parseFloat(dist[1]) * 100
                          ),
                          100,
                        ],
                  }));
                }}
                handleStyle={
                  hasChanged
                    ? [
                        {
                          display: "none",
                        },
                        {
                          border: "solid 2px #e57200",
                          backgroundColor: "#e57200",
                        },
                        {
                          border: "solid 2px #e57200",
                          backgroundColor: "#e57200",
                        },
                        {
                          display: "none",
                        },
                      ]
                    : [
                        {
                          display: "none",
                        },
                        {
                          border: "solid 2px #232d4b",
                          backgroundColor: "#232d4b",
                        },
                        {
                          border: "solid 2px #232d4b",
                          backgroundColor: "#232d4b",
                        },
                        {
                          display: "none",
                        },
                      ]
                }
                trackStyle={[
                  {
                    backgroundColor: "#6929ff",
                  },
                  {
                    backgroundColor: "#297fff",
                  },
                  {
                    backgroundColor: "#e864ff",
                  },
                ]}
              />
              <div className="flex flex-justify-between rangeValues">
                <h5>
                  Refugee:{" "}
                  <strong
                    style={{
                      color: "#6929ff",
                    }}
                  >
                    {values[1] - values[0]}%
                  </strong>
                </h5>
                <h5>
                  Subsidiary:{" "}
                  <strong
                    style={{
                      color: "#297fff",
                    }}
                  >
                    {values[2] - values[1]}%
                  </strong>
                </h5>
                <h5>
                  Humanitarian:{" "}
                  <strong
                    style={{
                      color: "#e864ff",
                    }}
                  >
                    {values[3] - values[2]}%
                  </strong>
                </h5>
              </div>
            </div>
          ) : (
            <div className="ps__dropdown p1 container">
              <span className="custom-dropdown">
                <select
                  value={value}
                  onChange={(e) => {
                    this.policyValueChanged(e, policyDetails.id);
                  }}
                >
                  {Object.keys(policyDetails.values)
                    .sort()
                    .map((item) => (
                      <option value={item} key={policyDetails.id - item}>
                        {policyDetails.values[item]}
                      </option>
                    ))}
                </select>
              </span>
              {/* <span className={"polIntensity"}>
                                <LinearProgress variant="determinate"
                                                classes={!hasChanged ? {
                                                    colorPrimary: classes.linearColorPrimary,
                                                    barColorPrimary: classes.linearBarColorPrimary,
                                                } : {
                                                    colorPrimary: classes.linearColorSecondary,
                                                    barColorPrimary: classes.linearBarColorSecondary,
                                                }}
                                                value={parseFloat((parseInt(value) - 1) / (Object.keys(policyDetails.values).length - 1)) * 100}/>
                            </span> */}
            </div>
          )}
        </div>
        <div className="ps__description pt2 pb2 pl1 pr1">
          {JSON.parse(policyDetails.description).map((item, index) => (
            <p key={`polDesc-${policyDetails.id}-${index}`}>{item}</p>
          ))}
        </div>
      </div>
    );
  }
}

PolicyItem.propTypes = {
  policyDetails: PropTypes.object.isRequired,
  onPolicyValueChanged: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  dist: PropTypes.array,
  hasChanged: PropTypes.bool,
};

export default withStyles(styles)(PolicyItem);
